module.exports = __webpack_public_path__ + "./assets/screenshot_cards.png";